import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './SlideoutFooter.scss';
import { getClassNameWithOptionalClass } from '../../Utils/ClassNameUtils';
import ReactTooltip from 'react-tooltip';

const propTypes = {
  showCancel: PropTypes.bool,
  showApply: PropTypes.bool,
  applyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  cancelText: PropTypes.string,
  applyClassName: PropTypes.string,
  cancelClassName: PropTypes.string,
  isApplyDisabled: PropTypes.bool,
  doApply: PropTypes.func.isRequired,
  doCancel: PropTypes.func,
  disabledText: PropTypes.string
};

const defaultProps = {
  showCancel: true,
  showApply: true,
  applyText: 'Apply',
  cancelText: 'Cancel',
  isApplyDisabled: false
};

const SlideoutFooterStandardButtons = props => {
  const { showCancel, showApply, applyText, cancelText, doApply, doCancel, isApplyDisabled, disabledText } = props;

  const applyClassName = getClassNameWithOptionalClass(
    `slideout-footer__apply-button pxl-btn pxl-btn-primary${isApplyDisabled ? ' disabled' : ''}`,
    props.applyClassName
  );
  const cancelClassName = getClassNameWithOptionalClass('slideout-footer__cancel-button', props.cancelClassName);
  const applyClick = isApplyDisabled ? null : doApply;

  const showDisabledText = isApplyDisabled && disabledText;

  return (
    <React.Fragment>
      {showCancel && (
        <a className={cancelClassName} onClick={doCancel}>
          {cancelText}
        </a>
      )}
      {showApply && (
        <Fragment>
          {disabledText ? (
            <Fragment>
              <button className={applyClassName} onClick={applyClick} data-tip={showDisabledText ? disabledText : null}>
                {applyText}
              </button>

              <ReactTooltip place="top" />
            </Fragment>
          ) : (
            <button className={applyClassName} onClick={applyClick}>
              {applyText}
            </button>
          )}
        </Fragment>
      )}
    </React.Fragment>
  );
};

SlideoutFooterStandardButtons.propTypes = propTypes;
SlideoutFooterStandardButtons.defaultProps = defaultProps;
export default SlideoutFooterStandardButtons;
